module.exports = __webpack_public_path__ + "img/Uniqa_Insurance_Group.d0b263ea.png";